import React, { useState } from 'react';
import resume, { ExperienceEntry, Position } from '../../data/resume';
import styles from './Experience.module.css';

interface PositionCardProps {
  position: Position;
  isFirst: boolean;
}

const PositionCard: React.FC<PositionCardProps> = ({ position, isFirst }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className={`${styles.position} ${isFirst ? styles.positionFirst : ''}`}>
      <div
        className={styles.positionHeader}
        onClick={() => setExpanded((e) => !e)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && setExpanded((v) => !v)}
      >
        <div className={styles.positionMeta}>
          <h3 className={styles.positionTitle}>{position.title}</h3>
          <span className={styles.period}>{position.period}</span>
        </div>
        <span className={`${styles.chevron} ${expanded ? styles.chevronUp : ''}`}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </div>
      {expanded && (
        <ul className={styles.bullets}>
          {position.bullets.map((bullet, i) => (
            <li key={i} className={styles.bullet}>
              <span className={styles.bulletDot} />
              {bullet}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

interface ExperienceCardProps {
  entry: ExperienceEntry;
}

const ExperienceCard: React.FC<ExperienceCardProps> = ({ entry }) => (
  <div className={styles.card}>
    <div className={styles.cardHeader}>
      <div>
        <h2 className={styles.company}>{entry.company}</h2>
        <p className={styles.companyMeta}>
          <span className={styles.location}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            {entry.location}
          </span>
        </p>
        <p className={styles.companyDescription}>{entry.companyDescription}</p>
      </div>
    </div>
    <div className={styles.positions}>
      {entry.positions.map((position, i) => (
        <PositionCard key={i} position={position} isFirst={i === 0} />
      ))}
    </div>
  </div>
);

const Experience: React.FC = () => (
  <section id="experience" className={styles.section}>
    <div className={styles.inner}>
      <h2 className={styles.sectionTitle}>Experience</h2>
      <div className={styles.timeline}>
        {resume.experience.map((entry, i) => (
          <ExperienceCard key={i} entry={entry} />
        ))}
      </div>
    </div>
  </section>
);

export default Experience;
